import { getLevelArrayMetric as r } from "../index4.js";
import { getLevelCountNorthFacingUnits as e } from "../level-metrics/index13.js";
const i = (t) => r(t, e);
export {
  i as getLevelArrayCountNorthFacingUnits
};
//# sourceMappingURL=index13.js.map
